import { Dashboard, CreatePlan } from '@/components';

export const CreatePlanPage = () => (
  <Dashboard openLogIn>
    <CreatePlan />
  </Dashboard>
);
